<template>
  <div class="actions-menu-wrapper" data-testid="actions-menu">
    <!-- Actions Menu Trigger Button -->
    <v-menu
      v-model="actionsMenuOpen"
      offset-y
      left
      transition="slide-y-transition"
      :close-on-content-click="false"
      data-testid="actions-menu__dropdown"
    >
      <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
        <v-tooltip left content-class="tooltip-left">
          <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <base-button
              v-bind="{ ...menuAttrs, ...tooltipAttrs }"
              v-on="{ ...menuOn, ...tooltipOn }"
              icon-style
              class="actions-menu-trigger"
              name="actions-menu"
              data-testid="actions-menu__trigger-btn"
              img-alt="Actions Menu"
              image="/img/icons/threedot.svg"
            />
          </template>
          <span>More Actions</span>
        </v-tooltip>
      </template>
      <v-card class="actions-menu-card" data-testid="actions-menu__card">
        <!-- Menu Header -->
        <v-card-title class="primary white--text py-2 px-4 d-flex align-center justify-space-between">
          <span class="text-subtitle-1 font-weight-medium">Actions</span>
          <base-button 
            icon-style
            dark 
            @click="actionsMenuOpen = false"
            data-testid="actions-menu__close-btn"
            icon="mdi-close"
          />
        </v-card-title>
        
        <v-list dense class="py-2" data-testid="actions-menu__list">
         
         

          <!-- RU Info -->
          <v-list-item
           v-if="!isRevenueBreakupMode && (ruTypeForDialog === 'soxid' || ruTypeForDialog === 'jv')"
            @click="openRUInfoDialog()"
            data-testid="actions-menu__ru-info-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/ru-info.svg" width="20" height="20" alt="RU Info" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>RU Info</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Status Insights -->
          <v-list-item
           v-if="!isRevenueBreakupMode && !hideStatusInsights"
            @click="handleMenuAction('open-status-insights-dialog')"
            data-testid="actions-menu__status-insights-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/status-insight.svg" width="20" height="20" alt="Status Insights" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Status Insights</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- User Info -->
          <v-list-item
          
            @click="handleMenuAction('open-user-list-dialog')"
            data-testid="actions-menu__user-info-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/user-info.svg" width="20" height="20" alt="User Info" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>User Info</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Download Excel -->
          <v-list-item
            v-if="(toggleview !== VIEW_MODES.CONSOLIDATED) || isRevenueBreakupMode"
            @click="handleMenuAction('download-excel')"
            data-testid="actions-menu__download-excel-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/download-excel.svg" width="20" height="20" alt="Download Excel" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Download Excel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Download PDF -->
          <v-list-item
            v-if="(toggleview !== VIEW_MODES.CONSOLIDATED) || isRevenueBreakupMode"
            @click="handleMenuAction('download-pdf')"
            data-testid="actions-menu__download-pdf-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/download-pdf.svg" width="20" height="20" alt="Download PDF" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Download PDF</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Conversation -->
          <v-list-item
            v-if="showConversation && workflowtext.length !== TOTAL_WORKFLOW_COUNT && toggleview !== VIEW_MODES.CONSOLIDATED && !isRevenueBreakupMode"
            @click="openConversationDialog()"
            data-testid="actions-menu__conversation-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/conversation.svg" width="20" height="20" alt="Conversation" />
            </v-list-item-icon>
            <v-list-item-content> 
              <v-list-item-title>
                Conversation 
                <v-icon v-if="!commentarycycledata.conversation_read" x-small color="primary" class="ml-1">mdi-circle</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Conversation Disabled State -->
          <v-list-item
            v-else-if="showConversation && workflowtext.length === TOTAL_WORKFLOW_COUNT  && !isRevenueBreakupMode"
            disabled
            data-testid="actions-menu__conversation-disabled-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/conversation.svg" width="20" height="20" alt="Conversation" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text--disabled">Conversation - {{ workflowsDisabledMessage }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Activity Log -->
          <v-list-item
            v-if="showActivityLog && !isRevenueBreakupMode"
            @click="openActivityLogDialog()"
            data-testid="actions-menu__activity-log-item"
          >
            <v-list-item-icon class="mr-3">
              <img src="/img/icons/activity-log.svg" width="20" height="20" alt="Activity Log" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Activity Log</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Download All RU Cycle - Commented out for now -->
          <!-- <v-list-item
            v-if="!isRevenueBreakupMode && !isviewonly"
            @click="handleMenuAction('download-all-ru-cycle-list')"
            data-testid="actions-menu__download-all-ru-cycle-item"
          >
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-table-arrow-down</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Download All {{ ruLabel }} Cycle</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <!-- Download All RU - Commented out for now -->
          <!-- <v-list-item
            v-if="!isRevenueBreakupMode && !isviewonly"
            @click="handleMenuAction('download-all-ru-list')"
            data-testid="actions-menu__download-all-ru-item"
          >
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-table-arrow-down</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Download All {{ ruLabel }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-card>
    </v-menu>

    <!-- Hidden components that render dialogs - these need to be in the DOM to work -->
    <div class="hidden-trigger-components">
      <!-- Conversation Component (Hidden Trigger) -->
      <lb-conversation 
        v-if="showConversation && workflowtext.length !== TOTAL_WORKFLOW_COUNT && toggleview !== VIEW_MODES.CONSOLIDATED"
        ref="conversationComponent"
        heading="Chats" 
        width="600" 
        :recurring="false"
        :recurringText="''" 
        :closed="cyclestage === 1 || isviewonly || workflowtext.length === TOTAL_WORKFLOW_COUNT"
        :highlight="!commentarycycledata.conversation_read"
        @markread="$emit('mark-conversation-read')"
        :notify="!commentarycycledata.conversation_read"
        :getapi="conversationApiBase + '/getconversation/' + conversationId"
        :sendapi="conversationApiBase + '/addconversation/' + conversationId"
        :readapi="conversationApiBase + '/markreadconversation/' + conversationId"
        :showprofile="false"
        :filter="{ reporting_type: reportingType }"
        data-testid="actions-menu__conversation-component"
      />

      <!-- Activity Log Component (Hidden Trigger) -->
      <lb-activitylog 
        v-if="showActivityLog"
        ref="activityLogComponent"
        :config="activitylogconfigcycle"
        :url="activityLogApiUrl"
        :filter="{ reporting_type: reportingType }"
        contentClass="tooltip-bottom-right"
        data-testid="actions-menu__activity-log-component"
      />

      <!-- RU Info Dialog -->
      <RUInfoDialog
        v-if="ruInfoDialogVisible"
        v-model="ruInfoDialogVisible"
        :ru-id="ruIdForDialog"
        :ru-type="ruTypeForDialog"
        :client-id="clientIdForDialog"
        data-testid="actions-menu__ru-info-dialog"
      />
    </div>
  </div>
</template>

<script>
/**
 * ActionsMenu Component
 * A standalone actions menu component extracted from GLActionToolbar
 * Provides bulk actions, downloads, and various commentary operations
 */
import RUInfoDialog from './RUInfoDialog.vue';
import { TOTAL_WORKFLOW_COUNT, VIEW_MODES } from '../utils/constants';

export default {
  name: 'ActionsMenu',
  components: {
    RUInfoDialog,
  },
  props: {
    /** @type {Object} Current commentary cycle data */
    commentarycycledata: { type: Object, default: () => ({}) },
    
    /** @type {Object} Workflow configuration */
    workflows: { type: Object, default: () => ({ islocalenabled: true, isregionalenabled: true }) },
    
    /** @type {Boolean} Whether SL (sub-ledger) actions are enabled */
    slEnabled: { type: Boolean, default: true },
    
    /** @type {Boolean} Whether current user is a regional approver */
    isregionalapprover: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is a preparer */
    ispreparer: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is an approver */
    isapprover: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user has view-only access */
    isviewonly: { type: Boolean, default: false },
    
    /** @type {String} Label for local commentary */
    commentary_local_key_label: { type: String, default: 'Local' },
    
    /** @type {String} Label for regional commentary */
    commentary_regional_key_label: { type: String, default: 'Regional' },
    
    /** @type {Number} Toggle between different view modes */
    toggleview: { type: Number, default: 0 },
    
    /** @type {Number} Toggle between table views */
    toggletableview: { type: Number, default: 0 },
    
    /** @type {Boolean} Whether local RU approval is pending */
    ispendinglocalruapproval: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether regional RU approval is pending */
    ispendingregionalruapproval: { type: Boolean, default: false },
    
    /** @type {String} Message to display when workflows are disabled */
    workflowsDisabledMessage: { type: String, default: 'workflow disabled' },
    
    /** @type {Array} Selected items for multi-select operations */
    multiselectdata: { type: Array, default: () => [] },
    
    /** @type {Number} Current cycle stage */
    cyclestage: { type: Number, default: 0 },
    
    /** @type {String|Array} Workflow text/status */
    workflowtext: { type: [String, Array], default: () => [] },
    
    /** @type {Object} Configuration for cycle-level activity log */
    activitylogconfigcycle: { type: Object, default: () => ({}) },
    
    /** @type {Boolean} Whether in revenue breakup mode */
    isRevenueBreakupMode: { type: Boolean, default: false },
    
    /** @type {String} API base path - 'analysis' for RUDataSection */
    apiBasePath: { type: String, default: 'analysis' },
    
    /** @type {Boolean} Whether preparer has actionable items */
    hasPreparerActionableItems: { type: Boolean, default: true },
    
    /** @type {String} Label for Reporting Unit (RU) */
    ruLabel: { type: String, default: 'RU' },
    
    /** @type {String} Reporting type filter - 'bs' (Balance Sheet), 'pl' (Profit & Loss), or 'both' */
    reportingType: { type: String, default: 'pl' },
    
    /** @type {Boolean} Whether to hide the Status Insights menu item (when shown externally) */
    hideStatusInsights: { type: Boolean, default: false },
    
    /** @type {String} SL Commentary ID - used for SL context activity log and conversation APIs */
    slCommentaryId: { type: String, default: '' },
  },
  data() {
    return {
      /** @type {Boolean} Actions menu open state */
      actionsMenuOpen: false,
      /** @type {Boolean} RU Info dialog visibility */
      ruInfoDialogVisible: false,
      /** @type {Number} Total number of workflows in a set */
      TOTAL_WORKFLOW_COUNT,
      /** @type {Object} View modes for Variance Analysis */
      VIEW_MODES,
    };
  },
  computed: {
    /**
     * Computed property to determine if conversation should be shown
     * @returns {Boolean} True if conversation should be visible
     */
    showConversation() {
      return (this.toggleview !== VIEW_MODES.CONSOLIDATED ) || this.isRevenueBreakupMode;
    },
    
    /**
     * Computed property to determine if activity log should be shown
     * @returns {Boolean} True if activity log should be visible
     */
    showActivityLog() {
      return (this.toggleview !== VIEW_MODES.CONSOLIDATED ) || this.isRevenueBreakupMode;
    },

    /**
     * Computed property for conversation API base path
     * Uses v2 for sl_analysis, v3 for analysis
     * @returns {String} API base path for conversation endpoints
     */
    conversationApiBase() {
      const version = this.apiBasePath === 'sl_analysis' ? 'v2' : 'v3';
      return `/${version}/varianceanalysis/${this.apiBasePath}`;
    },

    /**
     * Computed property for conversation ID
     * For SL context, uses slCommentaryId; otherwise uses commentarycycledata._id
     * @returns {String} The ID to use in conversation API URLs
     */
    conversationId() {
      if (this.apiBasePath === 'sl_analysis' && this.slCommentaryId) {
        return this.slCommentaryId;
      }
      return this.commentarycycledata._id || '';
    },

    /**
     * Computed property for activity log API URL
     * Uses v2 for sl_analysis, v3 for analysis
     * For SL context, uses slCommentaryId instead of commentarycycledata._id
     * @returns {String} Full API URL for activity log endpoint
     */
    activityLogApiUrl() {
      const version = this.apiBasePath === 'sl_analysis' ? 'v2' : 'v3';
      const id = this.apiBasePath === 'sl_analysis' && this.slCommentaryId 
        ? this.slCommentaryId 
        : this.commentarycycledata._id;
      const type = this.commentarycycledata.type || 'Actual';
      return `/${version}/varianceanalysis/${this.apiBasePath}/getlogs/${id}/f/${type}`;
    },

    /**
     * Computed property to get the RU ID for the dialog
     * The RU ID is stored in commentarycycledata.reportingunit_detail._id
     * @returns {String} The reporting unit ID
     */
    ruIdForDialog() {
      const data = this.commentarycycledata || {};
      
      // Priority order for finding RU ID:
      // 1. reportingunit_detail._id (primary source - nested object from API)
      // 2. reportingunit._id (alternative nested object)
      // 3. Direct properties: reporting_unit, reportingunit, ru_id, ruId
      const reportingUnitDetail = data.reportingunit_detail;
      const reportingUnit = data.reporting_unit || data.reportingunit || data.reportingUnit;
      
      let ruId = '';
      
      // Check reportingunit_detail first (most common structure)
      if (reportingUnitDetail && typeof reportingUnitDetail === 'object') {
        ruId = reportingUnitDetail._id || reportingUnitDetail.id || '';
      }
      // Check reporting_unit object
      else if (reportingUnit && typeof reportingUnit === 'object') {
        ruId = reportingUnit._id || reportingUnit.id || '';
      }
      // Check if reporting_unit is a direct string ID
      else if (reportingUnit && typeof reportingUnit === 'string') {
        ruId = reportingUnit;
      }
      // Fallback to direct ru_id properties
      else {
        ruId = data.ru_id || data.ruId || data.ruid || '';
      }
      
      console.log('[ActionsMenu]: ruIdForDialog resolved:', ruId, {
        reportingunit_detail: reportingUnitDetail,
        reporting_unit: reportingUnit,
      });
      
      return ruId;
    },

    /**
     * Computed property to get the RU type for the dialog
     * RU type is stored in Vuex filter state: actualfilter.selectedReportingUnitType or forecastfilter.selectedReportingUnitType
     * Valid values: 'soxid', 'jv' (API rejects 'all')
     * @returns {String} The reporting unit type (soxid or jv)
     */
    ruTypeForDialog() {
      const data = this.commentarycycledata || {};
      const store = this.$store?.state?.varianceanalysis || {};
      
      // Get RU type from Vuex filter state (primary source)
      // Filter.vue stores this in actualfilter or forecastfilter based on cycletype
      const actualFilterType = store.actualfilter?.selectedReportingUnitType;
      const forecastFilterType = store.forecastfilter?.selectedReportingUnitType;
      
      // Also check reportingunit_detail for type
      const reportingUnitDetailType = data.reportingunit_detail?.type;
      const reportingUnitType = data.reporting_unit?.type || data.reportingunit?.type;
      
      // Priority: reportingunit_detail.type > filter state > direct properties
      let ruType = reportingUnitDetailType
        || reportingUnitType
        || actualFilterType
        || forecastFilterType
        || data.ru_type 
        || data.ruType 
        || data.type
        || '';
      
      // API only accepts 'soxid' or 'jv', not 'all'
      // If type is 'all' or empty, we can't make a valid API call
      if (ruType === 'all') {
        ruType = '';
      }
      
      console.log('[ActionsMenu]: ruTypeForDialog resolved:', ruType, {
        reportingunit_detail_type: reportingUnitDetailType,
        actualFilterType,
        forecastFilterType,
        data_type: data.type,
      });
      
      return ruType;
    },

    /**
     * Computed property to get the client ID for the dialog
     * @returns {String} The client ID
     */
    clientIdForDialog() {
      return this.$store?.state?.client?._id || this.$store?.state?.client || '';
    },
  },
  methods: {
    /**
     * Opens the actions menu programmatically
     * Can be called via ref from parent component
     */
    openMenu() {
      this.actionsMenuOpen = true;
    },
    
    /**
     * Closes the actions menu
     */
    closeMenu() {
      this.actionsMenuOpen = false;
    },
    
    /**
     * Handles menu action click - emits the event and closes the menu
     * @param {String} eventName - The event name to emit
     * @param {Array} args - Optional arguments to pass with the event
     */
    handleMenuAction(eventName, args = []) {
      this.$emit(eventName, ...args);
      this.actionsMenuOpen = false;
    },
    
    /**
     * Opens the RU Info dialog
     * The dialog handles API call internally via Vuex
     */
    openRUInfoDialog() {
      this.actionsMenuOpen = false;
      this.ruInfoDialogVisible = true;
    },

    /**
     * Opens the Conversation dialog by triggering the lb-conversation component's internal method
     */
    openConversationDialog() {
      this.actionsMenuOpen = false;
      this.$nextTick(() => {
        if (this.$refs.conversationComponent) {
          this.$refs.conversationComponent.onConversationClick();
        }
      });
    },
    
    /**
     * Opens the Activity Log dialog by triggering the lb-activitylog component's internal method
     */
    openActivityLogDialog() {
      this.actionsMenuOpen = false;
      this.$nextTick(() => {
        if (this.$refs.activityLogComponent) {
          this.$refs.activityLogComponent.dialog = true;
          this.$refs.activityLogComponent.loadData();
        }
      });
    },
  },
};
</script>

<style scoped>
/* Actions Menu Wrapper */
.actions-menu-wrapper {
  display: inline-flex;
  align-items: center;
}

/* Actions menu trigger button */
.actions-menu-trigger {
  color: #666;
  transition: color 0.2s ease;
}

.actions-menu-trigger:hover {
  color: #333;
}

/* Actions Menu Card Styles */
.actions-menu-card {
  min-width: 280px;
  max-width: 350px;
  overflow: hidden;
}

.actions-menu-card .v-card__title {
  font-size: 0.95rem;
}

.actions-menu-card .v-list {
  max-height: 400px;
  overflow-y: auto;
}

/* Actions Menu List Item Styles */
.actions-menu-card .v-list-item {
  transition: background-color 0.2s ease;
}

.actions-menu-card .v-list-item:hover {
  background-color: #f5f5f5;
}

/* Text styling for menu items */
.actions-menu-card .v-list-item__title {
  color: var(--Grey-500, #828285) !important;
  font-size: var(--font-size-xs) !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 1.25rem !important;
  text-transform: capitalize !important;
  transition: color 0.2s ease;
}

/* Hover state - text color change */
.actions-menu-card .v-list-item:hover .v-list-item__title {
  color: var(--Text-Grey-Default, #2C2C35) !important;
}

.actions-menu-card .v-list-item__title.text--disabled {
  color: #bdbdbd;
}

/* Icon styling */
.actions-menu-card .v-list-item__icon {
  transition: color 0.2s ease;
}

.actions-menu-card .v-list-item__icon .v-icon {
  color: var(--Grey-500, #828285);
  transition: color 0.2s ease;
}

/* Hover state - icon color change */
.actions-menu-card .v-list-item:hover .v-list-item__icon .v-icon {
  color: var(--Text-Grey-Default, #2C2C35);
}

/* SVG icon styling */
.actions-menu-card .v-list-item__icon svg {
  transition: all 0.2s ease;
}

.actions-menu-card .v-list-item__icon svg path {
  transition: stroke 0.2s ease;
}

/* Hover state - SVG icon color change */
.actions-menu-card .v-list-item:hover .v-list-item__icon svg path {
  stroke: var(--Text-Grey-Default, #2C2C35);
}

/* Hidden trigger components - hide the button but allow dialog to render */
.hidden-trigger-components {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
}

.hidden-trigger-components .v-dialog__container {
  position: fixed !important;
  overflow: visible !important;
  pointer-events: auto;
}
</style>
